import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Table, Form, Spin, Select, Popover } from 'antd';
import { HomeOutlined, SearchOutlined, RedoOutlined, DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import Audit from '../../component/audit/audit';//審核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import moment from 'moment';//日期格式化导包
import trans from './translation';
import Message from '../../component/message/message';
import KeyDocumentFileTypeModal from '../../component/keyDocumentFileTypeModal/keyDocumentFileTypeModal';
import './keyDocumentRecord.css';
const { Option } = Select;

const KeyDocumentRecord = (props) => {

    const [form2] = Form.useForm();
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [cohortList, setCohortList] = useState([]);

    const tableColumns = {
        firstName: "first_name",
        studentAcctId: "student_acct_id",
        progTitle: "prog_title",
        cohortYear: "cohort_year",
        moduleCode: "module_code",
        moduleName: "module_name",
        fileTypeVal: "file_type_val",
        fileDesc: "file_desc",
        userName: "user_name",
        uploadedDate: "uploaded_date",
        status: "status",
    }

    useEffect(() => {
        searchCohortList()
        search(pageSize, 1, "N", false);
    }, []);

    const searchCohortList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("cohortProg/searchCohortList").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setCohortList(list)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newSearchModel => {
            return { ...newSearchModel, ...{ [k]: e } };
        })
    }

    //查询
    const search = (pageSizeNew, current, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        model.progCodeList = Config.userInfo?.progCodeList
        model.cohortYear = Config.cohort?.cohortYear
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("keyDocument/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //重置
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        form2.resetFields();
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    //添加
    const add = () => {
        messageShowHandler();//清空提示信息
        initForm({});
        setFlag("add");
        setTabIndex("2");
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            wpaApplId: model.wpaApplId ?? '',
            applyDate: (model.applyDate && moment(model.applyDate)) ?? null,
        });
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    // 审核弹窗
    const auditCancel = () => {
        setIsAudit(false);
    }

    const onSave = (model) => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        
    }

    //取消 
    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const onSearch = () => {
        search(pageSize, 1, "N")
    }

    const downloadFile = (item, e) => {
        e.stopPropagation();
        if (!Base.stopClick()){
            return;
        }
        if (!item.filePath) {
            errFrameShow('error', 'There is no file for this Key Document.');
            return;
        }
        Base.downloadFile(Config.keyDocument + item.filePath + '?' + Config.sasToken, item.fileName)
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Student ID',
            dataIndex: 'studentAcctId',
            width: '7%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: 'Student Name',
            dataIndex: 'firstName',
            width: '9%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'firstName') },
            render: (text, record) => record.firstName + ' ' + record.lastName
        },
        {
            title: 'Programme Name',
            dataIndex: 'progTitle',
            width: '11%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progTitle') },
        },
        {
            title: 'Module Cohort',
            dataIndex: 'cohortYear',
            width: '9%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'cohortYear') },
        },
        {
            title: 'Module Code',
            dataIndex: 'moduleCode',
            width: '9%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'moduleCode') },
        },
        {
            title: 'Module Name',
            dataIndex: 'moduleName',
            width: '10%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'moduleName') },
        },
        {
            title: () => 
                <div className='labelCircleBox'>
                    Type
                    <Popover placement="right" content={<div style={{ maxWidth: "1200px", textAlign: 'justify' }}>
                        <KeyDocumentFileTypeModal />
                    </div>} trigger="hover">
                        <div className='labelCircle'><InfoCircleOutlined /></div>
                    </Popover>
                </div>,
            dataIndex: 'fileTypeVal',
            width: '10%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'fileTypeVal') },
            render: (text, record) => text + (record?.exemptedHours ? ' (' + record?.exemptedHours + ' Hours)' : '')
        },
        {
            title: 'Description',
            dataIndex: 'fileDesc',
            width: '15%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'fileDesc') },
        },
        {
            title: 'Uploaded Date',
            dataIndex: 'uploadedDate',
            width: '10%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'uploadedDate') },
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
        },
        {
            title: 'Uploaded By',
            dataIndex: 'userName',
            width: '10%',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'userName') },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: 100,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'status') },
            render: text => ContextHandler.getMapValue('KeyDocumentStatusMap', text),
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            fixed: 'right',
            className: ' sysControls',
            width: 110,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => downloadFile(record, e)} hidden={Config.funcInfo.canView === "N"}><DownloadOutlined /> {trans.download[Config.backLang]}</div>
            </div>
        },
    ];
    /*eslint-enable*/

    return (
        <div id="container" className="template keyDocumentRecord">
            <div className='breadcrumb'>
                <HomeOutlined /> / {trans.admin[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Form form={form2} onFinish={onSearch}>
                        <div className='sysSearchRow sysSearchBox'>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.studentAcctId[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.studentAcctId || ''}
                                            placeholder={trans.studentAcctId[Config.backLang]}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('studentAcctId', e.target.value)}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // 只允许输入字母和数字
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">{trans.studentName[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.firstName || ''}
                                            placeholder={trans.studentName[Config.backLang]}
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('firstName', e.target.value)} />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle ">{trans.cohortYear[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]}
                                            value={searchModel.cohortId || ''}
                                            onChange={(e) => searchChange('cohortId', e)}
                                        >
                                            <Option value=''></Option>
                                            {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Programme Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.progTitle || ''}
                                            placeholder='Programme Name'
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('progTitle', e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Module Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.moduleName || ''}
                                            placeholder='Module Name'
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('moduleName', e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => form2.submit()} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                    <div className="sysLineEight"></div>
                    <div className="sysTable" id="tableOne">
                        <Table
                            scroll={{ x: 1800 }}
                            rowKey="keyDocumentId"
                            columns={columns} //列名
                            dataSource={tables} //数据
                            pagination={{  //分页
                                showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                onChange: onChange,            //上页下页或者跳页方法
                                onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                total: tablesCount,             //总共多少条数据
                                current: current,         //当前页
                                pageSize: pageSize,       //每页显示多少条数据
                                defaultCurrent: 1,                               //默认当前页为1
                                size: "small"
                            }}
                            onChange={handleTableChange}
                        />
                    </div>
                </Spin>
            </div>
        </div>
    )
}

export default KeyDocumentRecord;